export const SEMANTIC_MODEL_RELATIONSHIP_PROFILE = "relationship-profile";
export function isSemanticModelRelationshipProfile(entity) {
    return entity?.type.includes(SEMANTIC_MODEL_RELATIONSHIP_PROFILE) ?? false;
}
//# sourceMappingURL=relationship-profile.js.map